const ENV = "staging";
const BASE_API_URL = "https://api.staging.solutions.coinhouse.io";
export { BASE_API_URL, ENV };